import type { FieldCodec } from 'v5/core/entity-values/values.types';
import { customFieldColumns } from './customFieldColumns';
import { findCustomFieldRowForRead } from './customFieldRows';
import { INT4_RANGE, validateField, validation } from './validation';

function isEmpty(value: number | null): boolean {
  return value === null;
}

/**
 * NUMBER custom field, stored in `integer_value` (legacy `NUMBER.jsx`). Rows
 * an earlier v6 build wrote to `float_value` still read.
 */
export const numberCodec: FieldCodec<'number'> = {
  decode(entity, spec, ctx) {
    const row = findCustomFieldRowForRead(entity, spec.definition.id, ctx);
    return row?.integer_value ?? row?.float_value ?? null;
  },
  encode(value) {
    return {
      type: 'custom',
      columns: customFieldColumns({ integer_value: value })
    };
  },
  empty() {
    return null;
  },
  isEmpty,
  validate(value, spec) {
    return validateField(value, spec, isEmpty, value => {
      if (value === null) return validation.valid();
      if (!Number.isFinite(value)) {
        return validation.invalid({ code: 'not-a-number' });
      }
      // The contact schema types `integer_value` as an integer.
      if (!Number.isInteger(value)) {
        return validation.invalid({ code: 'whole-number' });
      }
      if (value < INT4_RANGE.min || value > INT4_RANGE.max) {
        return validation.invalid({ code: 'out-of-range', ...INT4_RANGE });
      }
      return validation.valid();
    });
  }
};
